import { Button, ButtonProps } from '@op/opds.opux';
import { MouseEvent } from 'react';
import { LinkProps, useHref, useLinkClickHandler } from 'react-router';

interface Props extends ButtonProps {
  to: LinkProps['to'];
}

const LinkButton = ({ href, to, onClick, ...buttonProps }: Props): JSX.Element => {
  const linkClickHandler = useLinkClickHandler(to);
  // href is not really used when navigating, but it is needed to make Button render as <a>
  const buttonHref = useHref(to) || href;
  const handleClick = (
    event: MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
  ): void => {
    if (onClick) {
      onClick(event as MouseEvent<HTMLButtonElement>);
    }
    linkClickHandler(event as MouseEvent<HTMLAnchorElement>);
  };
  return (
    <Button
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...buttonProps}
      href={buttonHref}
      onClick={handleClick}
    />
  );
};

export default LinkButton;
